export default __webpack_public_path__ + "static/media/bank-transfer.714d04a6.svg";